import {BaseProduct} from "./baseProduct";
import {TariffCountry} from "../tariffs/tariffCountry";
import {TariffSource} from "../tariffs/tariffSource";
/**
 * Created by alex.y on 8/8/2017.
 */
export class Product extends BaseProduct {

    public CustomerId: number;
    public BaseTariff: string;
    public Countries: TariffCountry[] = [];
    public Description: string;
    public Source: TariffSource;
    public ChangeOrders: boolean;

    public constructor() {
        super();
    }
}


// WEBPACK FOOTER //
// ./app/objects/products/product.ts